import React, {useState, useEffect, useContext, useRef} from 'react';
import ChantierInfoHistoriqueView from './ChantierInfoHistoriqueView';
import {MadricContext} from '../../../Context/MadricContext';
import {useParams} from 'react-router-dom';
import {historiqueProjet} from '../../../services/MadricService';
import HistoriqueFilter from './HistoriqueFilter';
import {getFacture, getUsers} from '../../../services/MadricService';
import moment from 'moment/moment';
import Spinner from '../../Spinner/Spinner';

/**
 *  L'accueil
 * @return {JSX}
 */
function ChantierInfoHistorique() {
  const {projectInfoObtained, projectInfo, setProjectInfo, listeEmploye, setListeEmploye, filterFormGlobal, filterForm, selectedOptions} = useContext(MadricContext);

  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const {id} = useParams();

  const [filteredHistorique, setFilteredHistorique] = useState([]);

  const [facture, setFactures] = useState([]);


  /**
   * Change les value du form
   * @param {*} event event
   */
  function handleChange(event) {
    filterForm.current = {
      ...filterForm.current,
      [event.target.name]: event.target.value,
    };
  }

  /**
   * filtre du extra 1
   * @param {*} event event
   */
  function handleCheckboxChange(event) {
    setReload(reload);
    filterForm.current = {
      ...filterForm.current,
      [event.target.name]: event.target.checked,
    };
  }

  /**
   * Change les value du form
   * @param {*} event event global
   */
  function handleCheckboxChangeGlobal(event) {
    filterFormGlobal.current = {
      ...filterFormGlobal.current,
      [event.target.name]: event.target.checked,
    };
  }

  /**
   * Change les value du form
   * @param {*} event event
   */
  function handleListChange(event) {
    filterForm.current = {
      ...filterForm.current,
      faNomFacture: event,
    };
  }

  /**
   * Change les value du form
   * @param {*} event event
   */
  function handleDateChangeDebut(event) {
    setReload((previous) => !previous);
    filterFormGlobal.current = {
      ...filterFormGlobal.current,
      dateDebut: event,
    };
  }

  /**
   * Change les value du form
   * @param {*} event event
   */
  function handleDateChangeFin(event) {
    setReload((previous) => !previous);
    filterFormGlobal.current = {
      ...filterFormGlobal.current,
      dateFin: event,
    };
  }

  /**
   * Change les value du form
   * @param {*} event event
   */
  function handleChangeGlobal(event) {
    filterFormGlobal.current = {
      ...filterFormGlobal.current,
      name: event,
    };

    setReload((previous) => !previous);
  }

  /**
   * Enleve les value du form
   */
  function removeFilter() {
    filterFormGlobal.current = {
      ...filterFormGlobal.current,
      dateDebut: '',
      dateFin: '',
    };


    filterData();
    setReload((previous) => !previous);
  }


  useEffect(() => {
    setIsLoading(true);

    getHistorique();
    //selectedOptions.current = [];
    fetchFactures();

    if (listeEmploye.length === 0) {
      fetchEmploye();
    }
  }, []);

  /**
 * Va chercher la liste d'employes
 */
  async function fetchEmploye() {
    const name = await getUsers();

    setListeEmploye(name);
  }

  /**
   * Vachercher toute l'historique
   */
  async function getHistorique() {
    const hasTodolist = projectInfoObtained.current.includes('todolist');
    const hasCheckin = projectInfoObtained.current.includes('checkin');
    const hasNote = projectInfoObtained.current.includes('note');
    const hasPhoto = projectInfoObtained.current.includes('photo');
    const hasPDF = projectInfoObtained.current.includes('file');

    projectInfoObtained.current = ['note', 'photo', 'todolist', 'file', 'checkin'];

    setIsLoading(true);
    const res = await historiqueProjet(id, hasTodolist, hasCheckin, hasNote, hasPhoto, hasPDF);

    const combinedArray = projectInfo.concat(res);

    combinedArray.sort((a, b) => {
      // First, compare by 'date'
      if (a.date < b.date) return 1;
      if (a.date > b.date) return -1;

      // If dates are equal, and user_name is "Martin," move "Martin" to the front
      if (a.date === b.date) {
        if (a.user_name === 'Martin Lanouette' && b.user_name !== 'Martin Lanouette') return -1;
        if (a.user_name !== 'Martin Lanouette' && b.user_name === 'Martin Lanouette') return 1;
      }

      // If dates and user_name are equal, compare by 'user_name'
      if (a.user_name < b.user_name) return -1;
      if (a.user_name > b.user_name) return 1;

      return 0; // Objects are considered equal
    });


    setFilteredHistorique((prev) => combinedArray);
    setProjectInfo(combinedArray);
    setIsLoading(false);
    //filterData();
  }

  /**
   * Va chercher la liste de factures
   */
  async function fetchFactures() {
    await getFacture().then((res) => {
      setFactures(res.map((item) => ({value: item.id, label: item.name})));
    });
  }

  const filterExtra = (item1, item2, item3) => {
    const {extra1, extra2, extra3} = filterFormGlobal.current;

    const areAllExtrasFalse = !extra1 && !extra2 && !extra3;
    const isItem1Matching = item1 === extra1 && item1;
    const isItem2Matching = item2 === extra2 && item2;
    const isItem3Matching = item3 === extra3 && item3;

    return areAllExtrasFalse || isItem1Matching || isItem2Matching || isItem3Matching;
  };

  /**
   * Filtre l'historique
   */
  function filterData() {
    const filterFormValues = filterForm.current;
    const selectedOptionsValues = selectedOptions.current;

    const filtered = projectInfo.filter((item) => {
      if (selectedOptionsValues.length === 0) {
        return true;
      }

      switch (item.type) {
        case 'todolist':
          return filterTodoList(item, filterFormValues);
        case 'checkin':
          return filterCheckin(item, filterFormValues);
        case 'photo':
          return filterPhoto(item, filterFormValues);
        case 'facture':
          return filterFacture(item, filterFormValues);
        case 'note':
          return filterNote(item, filterFormValues);
        case 'file':
          return filterFile(item, filterFormValues);
        default:
          return false;
      }
    });

    const date2 = moment.tz(filterFormGlobal.current.dateDebut, 'America/Montreal');
    const date3 = moment.tz(filterFormGlobal.current.dateFin, 'America/Montreal');

    const filteredArrays = filtered.filter((item) => {
      const date1 = moment.tz(item.date, 'America/Montreal');


      const userNameMatches = item.user_name.toLowerCase() === filterFormGlobal.current.name.label.toLowerCase() || filterFormGlobal.current.name.label === 'Filtrer par nom';
      const extraMatches = filterExtra(item.extra1, item.extra2, item.extra3);

      if (userNameMatches && extraMatches) {
        if (
          (filterFormGlobal.current.dateDebut === '' && filterFormGlobal.current.dateFin === '') ||
          (filterFormGlobal.current.dateDebut === '' && date1 <= date3) ||
          (filterFormGlobal.current.dateFin === '' && date1 >= date2) ||
          (date1 <= date3 && date1 >= date2)
        ) {
          return true;
        }
      }

      return false;
    });


    setFilteredHistorique(filteredArrays);
  }

  /**
   * Filtre la todolist
   * @param {*} item item
   * @param {*} formValues form
   * @return {*}
   */
  function filterTodoList(item, formValues) {
    if (selectedOptions.current.includes(item.type)) {
      if (!formValues.toNonComplete && !formValues.toComplete) {
        return true;
      } else {
        return (
          (item.complete === 1 && formValues.toComplete) ||
            (item.complete === 0 && formValues.toNonComplete)
        );
      }
    }
    return false;
  }

  /**
   * Filtre les checkins
   * @param {*} item item
   * @param {*} formValues form
   * @return {*}
   */
  function filterCheckin(item, formValues) {
    if (selectedOptions.current.includes(item.type)) {
      if (formValues.chNote === '' && !formValues.chTransport) {
        return true;
      } else {
        return (
          (item.transport === 1 && formValues.chTransport) ||
            (item.note !== null && formValues.chNote !== '' && item.note.includes(formValues.chNote))
        );
      }
    }
    return false;
  }

  /**
   * Filtre les photos
   * @param {*} item item
   * @param {*} formValues form
   * @return {*}
   */
  function filterPhoto(item, formValues) {
    if (selectedOptions.current.includes(item.type)) {
    
      if (formValues.phNote === '' && !formValues.phAvancement) {
        return true;
      } else {
        return (
          (item.avancement === true && formValues.phAvancement) ||
            (item.note !== null && formValues.phNote !== '' && item.note.includes(formValues.phNote))
        );
      }
    }
    return false;
  }

  /**
   * Filtre les factures
   * @param {*} item item
   * @param {*} formValues form
   * @return {*}
   */
  function filterFacture(item, formValues) {
    if (selectedOptions.current.includes(item.type)) {
      if (formValues.faNote === '' && !formValues.faAvancement && formValues.faNomFacture.length === 0) {
        return true;
      } else {
        return (
          (item.avancement === true && formValues.faAvancement) ||
            (item.note !== null && formValues.faNote !== '' && item.note.includes(formValues.faNote)) ||
            formValues.faNomFacture.some((i) => i.label === item.facturename)
        );
      }
    }
    return false;
  }

  /**
   * Filtre les notes
   * @param {*} item item
   * @param {*} formValues form
   * @return {*}
   */
  function filterNote(item, formValues) {
    if (selectedOptions.current.includes(item.type)) {
      return item.note === null || formValues.noNote === '' || item.note.includes(formValues.noNote);
    }
    return false;
  }

  /**
   * Filtre les fichiers
   * @param {*} item item
   * @param {*} formValues form
   * @return {*}
   */
  function filterFile(item, formValues) {
    if (selectedOptions.current.includes(item.type)) {
      if (formValues.pdNote === '' && !formValues.pdPermission) {
        return true;
      } else {
        return (
          (item.permission === true && formValues.pdPermission) ||
            (item.note !== null && formValues.pdNote !== '' && item.note.includes(formValues.pdNote))
        );
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <HistoriqueFilter
        facture={facture}
        selectedOptions={selectedOptions}
        filterData={filterData}
        setReload={setReload}
        filterForm={filterForm}
        handleChange={handleChange}
        handleCheckboxChange={handleCheckboxChange}
        handleListChange={handleListChange}
        filterFormGlobal={filterFormGlobal}
        handleCheckboxChangeGlobal={handleCheckboxChangeGlobal}
        handleDateChangeDebut={handleDateChangeDebut}
        handleDateChangeFin={handleDateChangeFin}
        handleChangeGlobal={handleChangeGlobal}
        removeFilter={removeFilter}
      />
      <ChantierInfoHistoriqueView
        historique={filteredHistorique}

      />
    </React.Fragment>
  );
}

export default ChantierInfoHistorique;
